(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("iE7OH", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $0380ce8f1f064ccc$export$6503ec6e8aabbaf; }, function (v) { return $0380ce8f1f064ccc$export$6503ec6e8aabbaf = v; });
var $0380ce8f1f064ccc$export$6503ec6e8aabbaf;
var $0380ce8f1f064ccc$export$f7ad0328861e2f03;
"use strict";
var $0380ce8f1f064ccc$var$mapping = new Map();
function $0380ce8f1f064ccc$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0380ce8f1f064ccc$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0380ce8f1f064ccc$var$resolve(id) {
    var resolved = $0380ce8f1f064ccc$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0380ce8f1f064ccc$export$6503ec6e8aabbaf = $0380ce8f1f064ccc$var$register;
$0380ce8f1f064ccc$export$f7ad0328861e2f03 = $0380ce8f1f064ccc$var$resolve;

});

parcelRegister("aNJCr", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $7dd1ddf6834435ca$export$bdfd709ae4826697; }, function (v) { return $7dd1ddf6834435ca$export$bdfd709ae4826697 = v; });
var $7dd1ddf6834435ca$export$bdfd709ae4826697;
var $7dd1ddf6834435ca$export$c9e73fbda7da57b6;
var $7dd1ddf6834435ca$export$5a759dc7a1cfb72a;
"use strict";
var $7dd1ddf6834435ca$var$bundleURL = {};
function $7dd1ddf6834435ca$var$getBundleURLCached(id) {
    var value = $7dd1ddf6834435ca$var$bundleURL[id];
    if (!value) {
        value = $7dd1ddf6834435ca$var$getBundleURL();
        $7dd1ddf6834435ca$var$bundleURL[id] = value;
    }
    return value;
}
function $7dd1ddf6834435ca$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $7dd1ddf6834435ca$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $7dd1ddf6834435ca$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $7dd1ddf6834435ca$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$7dd1ddf6834435ca$export$bdfd709ae4826697 = $7dd1ddf6834435ca$var$getBundleURLCached;
$7dd1ddf6834435ca$export$c9e73fbda7da57b6 = $7dd1ddf6834435ca$var$getBaseURL;
$7dd1ddf6834435ca$export$5a759dc7a1cfb72a = $7dd1ddf6834435ca$var$getOrigin;

});

var $28d048434f193c16$exports = {};


(parcelRequire("iE7OH")).register((parcelRequire("aNJCr")).getBundleURL("2u7YE"), JSON.parse('["2u7YE","index.579b3f4f.js","lm6AO","../ui-pack.01f87fb1.aac","6kufS","../Dial_up_modem_noises.fcf212dc.aac","b1Sfa","../fan-loop.00ef9ea2.wav","kbI6B","../RAIN_Heavy_loop_stereo_01.a46bc133.aac","iy2j6","../HZ_Allo.df799dd6.mp3","4H70u","../HZ_Vocal.d7be1088.mp3","cTuuq","../HZ_Merci.1af0b4b4.mp3"]'));

// Autrona Acoustic Computer Kernel Module: Audio
// Main Web Audio API module, takes care of creating and resuming
// Audio context, maintaining sources and providing some effects.
var $195f804eb85bb809$exports = {};

$parcel$export($195f804eb85bb809$exports, "load", function () { return $195f804eb85bb809$export$11e63f7b0f3d9900; });
$parcel$export($195f804eb85bb809$exports, "play", function () { return $195f804eb85bb809$export$899fbdb5fa08b653; });
$parcel$export($195f804eb85bb809$exports, "audioBuffers", function () { return $195f804eb85bb809$export$c2a342ec653dfb48; });
// Audio kernel module: Buffer
// Manages loading, decoding and plaback of audioBuffers

// References
const $195f804eb85bb809$export$c2a342ec653dfb48 = {};
function $195f804eb85bb809$export$11e63f7b0f3d9900(name, url, progress = null) {
    const request = new XMLHttpRequest();
    const promise = new Promise((resolve, reject)=>{
        request.open("GET", url, true);
        request.responseType = "arraybuffer";
        request.onload = ()=>{
            resolve($195f804eb85bb809$var$decode(name, request.response));
        };
        request.onerror = ()=>{
            reject();
            console.error(`An error occured while getting '${name}' audio from '${url}'`);
        };
        request.onprogress = (e)=>{
            const percent = Math.round(e.loaded / e.total * 100);
            if (typeof progress === "function") progress(percent);
            if (DEVMODE) console.log(`Progress loading '${name}' audio file`, percent + "%");
        };
        request.send();
    });
    return promise;
}
function $195f804eb85bb809$var$decode(name, arrayBuffer) {
    const promise = new Promise((resolve, reject)=>{
        $d483974069d0054d$export$a078c61943f9dbbe.decodeAudioData(arrayBuffer, (buffer)=>{
            $195f804eb85bb809$export$c2a342ec653dfb48[name] = buffer;
            resolve();
            if (DEVMODE) console.log(`Decoded '${name}' audio buffer`);
        }, (e)=>{
            reject();
            console.error("Error while decoding audio data: " + e);
        });
    });
    return promise;
}
function $195f804eb85bb809$export$899fbdb5fa08b653(name, options = {}) {
    if ($195f804eb85bb809$export$c2a342ec653dfb48[name] === undefined) {
        console.error(`Play error: '${name}' audio buffer does not exist.`);
        return false;
    }
    $d483974069d0054d$export$fbb4d68fe60c1629();
    // Create a new source
    const source = $d483974069d0054d$export$a078c61943f9dbbe.createBufferSource();
    const gainNode = $d483974069d0054d$export$a078c61943f9dbbe.createGain();
    if (options.initialGain != undefined) // Note: this initial gain value will only be applied after that time
    // have passed (it does not change immediately).
    gainNode.gain.setValueAtTime($d483974069d0054d$export$33ed28de027e9482(options.initialGain), $d483974069d0054d$export$a078c61943f9dbbe.currentTime);
    source.gainNode = gainNode; // custom property for reference
    source.fadeTo = $d483974069d0054d$export$549ee30ac73cf40b; // custom function
    source.fade = $d483974069d0054d$export$cbea29d068a2e18f; // custom function
    source.connect(gainNode);
    gainNode.connect(options.destination || $d483974069d0054d$export$a078c61943f9dbbe.destination);
    // Optional looping parameters
    source.loop = options.loop || false;
    source.loopStart = options.loopStart || 0;
    source.loopEnd = options.loopEnd || 0;
    // Optional starting parameters
    const when = (options.when || 0) + $d483974069d0054d$export$a078c61943f9dbbe.currentTime;
    const offset = options.offset || 0;
    const duration = options.duration || undefined;
    // ... more options to come (detune, playBackRate)?
    // Assign an already loaded and decoded buffer
    source.buffer = $195f804eb85bb809$export$c2a342ec653dfb48[name];
    // On ended event
    source.onended = ()=>{
        if (typeof options.onended === "function") options.onended();
        $d483974069d0054d$export$93c25f2590a5b540(source);
    };
    // Start producing sound
    if (options.defer === undefined) source.start(when, offset, duration);
    // Maintain references to this source
    $d483974069d0054d$export$d1d41f0cda037248.push(source);
    return source;
}


// References
let $d483974069d0054d$export$a078c61943f9dbbe;
const $d483974069d0054d$export$d1d41f0cda037248 = [];
function $d483974069d0054d$export$2cd8252107eb640b() {
    // Create AudioContext
    if (typeof AudioContext !== "undefined") $d483974069d0054d$export$a078c61943f9dbbe = new AudioContext();
    else // For Safari
    $d483974069d0054d$export$a078c61943f9dbbe = new webkitAudioContext();
    if (DEVMODE) console.log("Audio context sample rate: " + $d483974069d0054d$export$a078c61943f9dbbe.sampleRate);
}
function $d483974069d0054d$export$fbb4d68fe60c1629() {
    // Resume context, dealing with autoplay policy
    if ($d483974069d0054d$export$a078c61943f9dbbe.state === "suspended") {
        if (DEVMODE) console.log("Resuming AudioContext");
        return $d483974069d0054d$export$a078c61943f9dbbe.resume();
    } else return Promise.resolve();
}
// Fade to an absolute level in db
// Default to a fade in behavior from -90db
// this function is used as a source method 
function $d483974069d0054d$export$549ee30ac73cf40b(time = 2, level = 0, fromLevel = -90, mode = "linear") {
    this.gainNode.gain.setValueAtTime($d483974069d0054d$export$33ed28de027e9482(fromLevel), $d483974069d0054d$export$a078c61943f9dbbe.currentTime);
    if (mode === "linear") this.gainNode.gain.linearRampToValueAtTime($d483974069d0054d$export$33ed28de027e9482(level), $d483974069d0054d$export$a078c61943f9dbbe.currentTime + time);
    else this.gainNode.gain.exponentialRampToValueAtTime($d483974069d0054d$export$33ed28de027e9482(level), $d483974069d0054d$export$a078c61943f9dbbe.currentTime + time);
    return this;
}
// Fade to a new level by applying a relative db gain
// Defaults to a fade out behavior
// this function is used as a source method 
function $d483974069d0054d$export$cbea29d068a2e18f(time = 2, db = -90, andStop = false, mode = "linear") {
    const currentGain = this.gainNode.gain.value;
    // This setValueAtTime call below is required for Firefox and Safari.
    // Otherwise, linearRampToValueAtTime will do nothing until
    // ac.currentTime + time is reached and then immeditaley drop to -90db.
    // Is this a bug?
    this.gainNode.gain.setValueAtTime(currentGain, $d483974069d0054d$export$a078c61943f9dbbe.currentTime);
    if (mode === "linear") this.gainNode.gain.linearRampToValueAtTime(currentGain * $d483974069d0054d$export$33ed28de027e9482(db), $d483974069d0054d$export$a078c61943f9dbbe.currentTime + time);
    else this.gainNode.gain.exponentialRampToValueAtTime(currentGain * $d483974069d0054d$export$33ed28de027e9482(db), $d483974069d0054d$export$a078c61943f9dbbe.currentTime + time);
    if (andStop) this.stop($d483974069d0054d$export$a078c61943f9dbbe.currentTime + time);
    return this;
}
function $d483974069d0054d$export$51b36263b660c3ee(time = 2, finalGain = -90) {
    // Fade out all sources and stop them
    $d483974069d0054d$export$d1d41f0cda037248.forEach((s)=>s.fade(time, finalGain, true));
}
function $d483974069d0054d$export$33390c3a9a83a2f() {
    $d483974069d0054d$export$d1d41f0cda037248.forEach((s)=>s.stop());
}
function $d483974069d0054d$export$93c25f2590a5b540(source) {
    const index = $d483974069d0054d$export$d1d41f0cda037248.indexOf(source);
    $d483974069d0054d$export$d1d41f0cda037248.splice(index, 1);
}
function $d483974069d0054d$export$e2eaa0ea75f89eaa(gain) {
    return 20 * log10(gain);
    function log10(x) {
        return Math.log(x) / Math.LN10;
    }
}
function $d483974069d0054d$export$33ed28de027e9482(db) {
    return Math.pow(10, db / 20);
}


// Autrona Acoustic Computer Kernel Module: Screen
// Handle all text screen drawing, save/restore, lines management, styles,
// teletype animations and sequences of this UNIX-like terminal emulation.
// Utilities
//
// Project-wide utility functions
function $4a239e940479063f$export$10ce5528abfb398a(source, dest) {
    // Overwrite destination object values for keys that exists in the source object
    Object.getOwnPropertyNames(dest).forEach((key)=>{
        if (Object.prototype.hasOwnProperty.call(source, key)) dest[key] = source[key];
    });
}
// Extract lines from a long string at word breaks before given length param
// Return an array of trimmed lines
function $4a239e940479063f$export$89440da1893f4202(str, length) {
    const lines = [];
    if (str.length <= length) lines.push(str);
    else {
        let s = str;
        while(s.length > 0){
            let line;
            if (s.length > length) line = s.slice(0, s.slice(0, length).lastIndexOf(" "));
            else line = s;
            if (line.length > 0) {
                s = s.slice(line.length);
                lines.push(line.trim());
            } else s = "";
        }
    }
    return lines;
}
function $4a239e940479063f$export$7d15b64cf5a3a4c4(value, min = 0, max = 1) {
    return Math.max(min, Math.min(value, max));
}
function $4a239e940479063f$var$constrain(n, low, high) {
    return Math.max(Math.min(n, high), low);
}
let $4a239e940479063f$var$newval;
function $4a239e940479063f$export$aee1dbae5de2db9d(n, start1, stop1, start2, stop2, withinBounds) {
    $4a239e940479063f$var$newval = (n - start1) / (stop1 - start1) * (stop2 - start2) + start2;
    if (!withinBounds) return $4a239e940479063f$var$newval;
    if (start2 < stop2) return $4a239e940479063f$var$constrain($4a239e940479063f$var$newval, start2, stop2);
    return $4a239e940479063f$var$constrain($4a239e940479063f$var$newval, stop2, start2);
}



// Autrona Acoustic Computer Kernel Module: Keyboard
// Handle all key strokes, keep track of modifiers, 
// then pass the events to the currently running program,
// including main for control-sequences
// Configuration
const $43d5f93eb8bd2a33$var$modifiers = [
    "Control"
];
const $43d5f93eb8bd2a33$var$defaultPrevented = [
    " ",
    "ArrowUp",
    "ArrowDown"
];
// Variables
const $43d5f93eb8bd2a33$export$58b6cc66cb100704 = [];
// Initialize module
function $43d5f93eb8bd2a33$export$2cd8252107eb640b() {
    document.addEventListener("keydown", $43d5f93eb8bd2a33$var$handleKeyDowns);
    document.addEventListener("keyup", $43d5f93eb8bd2a33$var$handleKeyUps);
}
// General keydown event callback
function $43d5f93eb8bd2a33$var$handleKeyDowns(e) {
    //console.log('Keystroke:', e.key)
    if ($43d5f93eb8bd2a33$var$modifiers.includes(e.key)) $43d5f93eb8bd2a33$var$addModifier(e.key);
    if ($43d5f93eb8bd2a33$var$defaultPrevented.includes(e.key)) e.preventDefault();
}
// keyup event callback
function $43d5f93eb8bd2a33$var$handleKeyUps(e) {
    if ($43d5f93eb8bd2a33$var$modifiers.includes(e.key)) $43d5f93eb8bd2a33$var$removeModifier(e.key);
}
// Modifier keys handling
function $43d5f93eb8bd2a33$var$addModifier(key) {
    $43d5f93eb8bd2a33$export$58b6cc66cb100704.push(key);
}
function $43d5f93eb8bd2a33$var$removeModifier(key) {
    const modifierIndex = $43d5f93eb8bd2a33$export$58b6cc66cb100704.indexOf(key);
    $43d5f93eb8bd2a33$export$58b6cc66cb100704.splice(modifierIndex, 1);
}


// Variables
let $89b2e5ff48034291$var$screen;
let $89b2e5ff48034291$var$container;
let $89b2e5ff48034291$var$saveBuffer;
let $89b2e5ff48034291$var$unveilBuffer;
let $89b2e5ff48034291$var$currentLine;
let $89b2e5ff48034291$var$overflow = "scroll"; // scroll or clear
let $89b2e5ff48034291$var$timeout;
let $89b2e5ff48034291$var$timeoutBis;
const $89b2e5ff48034291$var$screenCols = 80;
const $89b2e5ff48034291$var$screenLines = 42;
// Initialize module
function $89b2e5ff48034291$export$2cd8252107eb640b() {
    $89b2e5ff48034291$var$screen = document.querySelector(".screen");
    $89b2e5ff48034291$var$container = document.querySelector(".container");
}
function $89b2e5ff48034291$export$c63191ea74413a1c(mode) {
    $89b2e5ff48034291$var$overflow = mode;
}
function $89b2e5ff48034291$export$a1544dad697b423d() {
    $89b2e5ff48034291$var$saveBuffer = $89b2e5ff48034291$var$screen.innerHTML;
}
function $89b2e5ff48034291$export$db239ef39aadc7fe() {
    clearTimeout($89b2e5ff48034291$var$timeout);
    clearTimeout($89b2e5ff48034291$var$timeoutBis);
    $89b2e5ff48034291$var$screen.innerHTML = $89b2e5ff48034291$var$saveBuffer;
    $89b2e5ff48034291$var$currentLine = $89b2e5ff48034291$var$screen.querySelector("p:last-of-type");
}
function $89b2e5ff48034291$export$42ffd38884aecdac(includePinned = true) {
    if (includePinned) {
        $89b2e5ff48034291$var$screen.innerHTML = "";
        $89b2e5ff48034291$var$currentLine = null;
        clearTimeout($89b2e5ff48034291$var$timeout);
        clearTimeout($89b2e5ff48034291$var$timeoutBis);
    } else $89b2e5ff48034291$var$screen.querySelectorAll("p:not(.pinned)").forEach((p)=>p.remove());
}
function $89b2e5ff48034291$export$10d8903dec122b9d(content, ...style) {
    if (style.length) $89b2e5ff48034291$export$3086f70939fb96fa(...style);
    $89b2e5ff48034291$var$currentLine.innerText += content;
    if (DEVMODE) $89b2e5ff48034291$var$checkLineLength($89b2e5ff48034291$var$currentLine.innerText);
    $89b2e5ff48034291$var$scroll();
}
function $89b2e5ff48034291$export$57ec1e98c75cb636(content, ...style) {
    if (style.length) $89b2e5ff48034291$export$3086f70939fb96fa(...style);
    $89b2e5ff48034291$var$currentLine.innerHTML += content;
    if (DEVMODE) $89b2e5ff48034291$var$checkLineLength($89b2e5ff48034291$var$currentLine.innerText);
    $89b2e5ff48034291$var$scroll();
}
function $89b2e5ff48034291$var$scroll() {
    // Scroll to bottom if necessary
    if ($89b2e5ff48034291$var$container.scrollTop !== $89b2e5ff48034291$var$container.scrollHeight) setTimeout(()=>{
        $89b2e5ff48034291$var$container.scrollTop = $89b2e5ff48034291$var$container.scrollHeight;
    }, 0);
}
function $89b2e5ff48034291$export$21a5ca8aa77d35ff(content, ...style) {
    $89b2e5ff48034291$export$dc84f6841f96b7da();
    $89b2e5ff48034291$export$10d8903dec122b9d(content, ...style);
}
function $89b2e5ff48034291$export$5a813221cd493211(content, ...style) {
    $89b2e5ff48034291$export$dc84f6841f96b7da();
    $89b2e5ff48034291$export$57ec1e98c75cb636(content, ...style);
}
function $89b2e5ff48034291$export$296e2d3e74e50369(content, ...style) {
    content.split("\n").forEach((c)=>$89b2e5ff48034291$export$21a5ca8aa77d35ff(c, ...style));
}
function $89b2e5ff48034291$export$91698095bd4ff7e0(content, ...style) {
    content.split("\n").forEach((c)=>$89b2e5ff48034291$export$5a813221cd493211(c, ...style));
}
function $89b2e5ff48034291$var$checkLineLength(content) {
    if (content.length > $89b2e5ff48034291$var$screenCols) console.warn("Warning: Content is larger than screen columns: " + content.length, content);
}
// Delete one (or more if specified) characters from the screenBuffer
function $89b2e5ff48034291$export$1ea584ca7009bcc1(n = 1) {
    $89b2e5ff48034291$var$currentLine.innerText = $89b2e5ff48034291$var$currentLine.innerText.slice(0, -n);
}
function $89b2e5ff48034291$export$dc84f6841f96b7da() {
    // Remove blinking cursor and/or dots if active
    if ($89b2e5ff48034291$var$currentLine) $89b2e5ff48034291$var$currentLine.classList.remove("cursor");
    if ($89b2e5ff48034291$var$currentLine) $89b2e5ff48034291$var$currentLine.classList.remove("dots");
    // Limit screen rows to screenLines
    if ($89b2e5ff48034291$var$screen.querySelectorAll("p").length >= $89b2e5ff48034291$var$screenLines) {
        if ($89b2e5ff48034291$var$overflow === "clear") $89b2e5ff48034291$export$42ffd38884aecdac(false);
        else // Remove the first paragraph which is not pinned
        $89b2e5ff48034291$var$screen.querySelector("p:not(.pinned)").remove();
    }
    // Create a new paragraph
    const p = document.createElement("p");
    $89b2e5ff48034291$var$screen.appendChild(p);
    $89b2e5ff48034291$var$currentLine = p;
}
function $89b2e5ff48034291$export$b78008adb124fd21(n = 1) {
    for(let i = 0; i < n; i++){
        $89b2e5ff48034291$var$currentLine.remove();
        $89b2e5ff48034291$var$currentLine = $89b2e5ff48034291$var$screen.querySelector("p:last-of-type");
    }
}
function $89b2e5ff48034291$export$3086f70939fb96fa(...style) {
    $89b2e5ff48034291$var$currentLine.classList.add(...style);
}
function $89b2e5ff48034291$export$35bfa795e607ffd5() {
    $89b2e5ff48034291$var$currentLine.classList.add("pinned");
}
function $89b2e5ff48034291$export$58734539bbfa41a2() {
    $89b2e5ff48034291$var$currentLine.classList.add("cursor");
}
function $89b2e5ff48034291$export$e5383273bc7bedd() {
    // add three bouncing animated dots
    $89b2e5ff48034291$var$currentLine.classList.add("dots");
}
function $89b2e5ff48034291$export$6c9a7cc621cd09fe() {
    if ($89b2e5ff48034291$var$currentLine) $89b2e5ff48034291$var$currentLine.classList.remove("dots");
}
function $89b2e5ff48034291$export$36a3a8a63357453b(content, n = null) {
    if (n == null) n = $89b2e5ff48034291$var$screen.querySelectorAll("p").length;
    $89b2e5ff48034291$var$screen.querySelector(`p:nth-child(${n})`).innerHTML = content;
}
function $89b2e5ff48034291$export$14c7f8fd9e0dc60b() {
    const linesToFill = $89b2e5ff48034291$var$screenLines - $89b2e5ff48034291$var$screen.querySelectorAll("p").length;
    for(let i = 0; i < linesToFill; i++)$89b2e5ff48034291$export$dc84f6841f96b7da();
}
// Automated teletype
// Will append `string` to the current line one character at a time,
// with `delay` milliseconds between each character.
function $89b2e5ff48034291$export$5938cf5cddbfce5a(string, delay = 33, callback = null) {
    if (string.length > 0) {
        let charDelay = delay;
        if (delay === "00" || delay == "human") charDelay = Math.floor(Math.random() * 8) ** 2 + 50;
        // Handle inline delays
        let inlineDelayMatch = string.match(/^(§([0-9]+)).*$/);
        if (inlineDelayMatch) {
            charDelay = inlineDelayMatch[2];
            string = string.replace(inlineDelayMatch[1], "").trim();
        }
        // Remove delays for development
        if (DEVMODE && $43d5f93eb8bd2a33$export$58b6cc66cb100704.includes("Control")) charDelay = 16;
        $89b2e5ff48034291$var$timeout = setTimeout(()=>{
            if (string.slice(0, 1) === "\xa7") $89b2e5ff48034291$export$1ea584ca7009bcc1();
            else $89b2e5ff48034291$export$10d8903dec122b9d(string.slice(0, 1));
            string = string.slice(1);
            $89b2e5ff48034291$export$5938cf5cddbfce5a(string, delay, callback);
        }, charDelay);
    } else if (typeof callback == "function") callback();
}
// Screen sequence
// A sequence of steps, each can be of different types
//  `Any text`         (string).     Will append the text to the current line.
//  `!n`               (new line).   Will open a new line.
//  `!c`               (clear).      Will clear the screen
//  `!s:my-class`      (CSS class).  Will add 'my-class' to the current line.
//  `!t:anytext:delay` (teletype).   Will teletype a string with given delay between each character
//  `!H:anytext      ` (HTML).       Will append the HTML to the current line.
//  `500`              (number).     Will delay further steps by X milliseconds.
function $89b2e5ff48034291$export$49bb65c2ea163039(seq, callback) {
    if (seq.length > 0) {
        const step = seq[0];
        if (typeof step == "string") {
            let matchNewLine = step.match(/^!n$/);
            let matchClear = step.match(/^!c$/);
            let matchStyle = step.match(/^!s:([a-z0-9\-]+)$/);
            let matchTeletype = step.match(/^!t:(.+):([0-9]+)$/);
            let matchHTML = step.match(/^!h:(.+)$/);
            switch(true){
                case matchNewLine != null:
                    $89b2e5ff48034291$export$dc84f6841f96b7da();
                    break;
                case matchClear != null:
                    $89b2e5ff48034291$export$42ffd38884aecdac();
                    break;
                case matchStyle != null:
                    $89b2e5ff48034291$export$3086f70939fb96fa(matchStyle[1]);
                    break;
                case matchTeletype != null:
                    $89b2e5ff48034291$export$5938cf5cddbfce5a(matchTeletype[1], matchTeletype[2], ()=>{
                        // When teletype finished, recursively step ahead in sequence
                        $89b2e5ff48034291$export$49bb65c2ea163039(seq.slice(1), callback);
                    });
                    break;
                case matchHTML != null:
                    $89b2e5ff48034291$export$57ec1e98c75cb636(matchHTML[1]);
                    break;
                default:
                    $89b2e5ff48034291$export$10d8903dec122b9d(step);
            }
            // Recursively step ahead in sequence
            if (!matchTeletype) $89b2e5ff48034291$export$49bb65c2ea163039(seq.slice(1), callback);
        } else if (typeof step == "number") // Recursively step ahead in sequence with a milliseconds delay
        $89b2e5ff48034291$var$timeout = setTimeout(()=>{
            $89b2e5ff48034291$export$49bb65c2ea163039(seq.slice(1), callback);
        }, step);
    } else callback();
}
// New screen sequence
// A sequence of multi-line text which is to be rendered on screen
// Default mode is teletype, each caracter appended to screen one at a time
// with human-like timing.
// Handles a post-lead line delay token in the sequence: '§2000' for a 2s delay
// TODO: BBCode-like markup: (Should be implemented in teletype fonction ?)
//   - [s:col-green]...[/s] Styling with spans
function $89b2e5ff48034291$export$b28a6436aebad9c0(seq, opts, callback = null) {
    const options = {
        /* Default options */ mode: "teletype",
        color: "col-orange",
        lead: "",
        lineDelay: 1000,
        dotsDelay: 2000,
        endDelay: 1000,
        newLineAtStart: true,
        newLineAtEnd: true,
        teletypeDelay: "human"
    };
    // Overwrite any default option with `opts` parameter
    $4a239e940479063f$export$10ce5528abfb398a(opts, options);
    if (seq.length > 0) {
        if (options.newLineAtStart) {
            $89b2e5ff48034291$export$dc84f6841f96b7da();
            options.newLineAtStart = false; // To cancel new line from recursive use
        }
        // Get sequence lines as an array
        let lines = seq.split("\n");
        // Get the first line
        let line = lines[0];
        // Remove any white-space around that line (code indents mostly)
        line = line.trim();
        openLine();
        // Find optional an line delay at the string's start (`§500` for a 500ms delay)
        let lineDelay = options.lineDelay;
        let lineDelayMatch = line.match(/^(§([0-9]+)).*$/);
        if (lineDelayMatch) {
            lineDelay = lineDelayMatch[2];
            line = line.replace(lineDelayMatch[1], "").trim();
        }
        // Remove delays for development
        if (DEVMODE && $43d5f93eb8bd2a33$export$58b6cc66cb100704.includes("Control")) lineDelay = 0;
        // After the first lead occurence, replace all characters with spaces
        options.lead = "".padStart(options.lead.length);
        // Prepare remaining sequence (this line excluded) for recursive use
        const remainingSeq = lines.slice(1).join("\n");
        // For teletype, display dots after 2 seconds if the line delay is longer than 2 seconds
        if (options.mode === "teletype" && lineDelay > options.dotsDelay) $89b2e5ff48034291$var$timeoutBis = setTimeout($89b2e5ff48034291$export$e5383273bc7bedd, options.dotsDelay);
        $89b2e5ff48034291$var$timeout = setTimeout(()=>{
            // Default mode: teletype
            switch(options.mode){
                case "line":
                    $89b2e5ff48034291$export$6c9a7cc621cd09fe();
                    $89b2e5ff48034291$export$10d8903dec122b9d(line);
                    $89b2e5ff48034291$export$b28a6436aebad9c0(remainingSeq, options, callback);
                    break;
                case "teletype":
                    $89b2e5ff48034291$export$6c9a7cc621cd09fe();
                    const lines = $4a239e940479063f$export$89440da1893f4202(line, 80 - options.lead.length);
                    teletypeMultiline(lines.shift());
                    function teletypeMultiline(line) {
                        $89b2e5ff48034291$export$5938cf5cddbfce5a(line, options.teletypeDelay, ()=>{
                            // Handling multiline teletype
                            if (lines.length) {
                                openLine();
                                teletypeMultiline(lines.shift());
                            } else // Recursively step ahead in sequence
                            $89b2e5ff48034291$export$b28a6436aebad9c0(remainingSeq, options, callback);
                        });
                    }
                    break;
                case "message":
                    const charDelay = 100; // How much time per char before printing this line
                    $89b2e5ff48034291$export$e5383273bc7bedd();
                    $89b2e5ff48034291$var$timeout = setTimeout(()=>{
                        $89b2e5ff48034291$export$6c9a7cc621cd09fe();
                        $89b2e5ff48034291$export$5938cf5cddbfce5a(line, options.teletypeDelay, ()=>{
                            // Recursively step ahead in sequence
                            $89b2e5ff48034291$export$b28a6436aebad9c0(remainingSeq, options, callback);
                        });
                    }, line.length * charDelay);
                    break;
            }
        }, lineDelay);
    } else $89b2e5ff48034291$var$timeout = setTimeout(()=>{
        if (options.newLineAtEnd) $89b2e5ff48034291$export$dc84f6841f96b7da();
        if (callback) callback();
    }, options.endDelay);
    function openLine() {
        // Add lead
        $89b2e5ff48034291$export$21a5ca8aa77d35ff(options.lead);
        // Style line
        if (typeof options.color === "string") $89b2e5ff48034291$export$3086f70939fb96fa(options.color);
        else $89b2e5ff48034291$export$3086f70939fb96fa(...options.color);
    }
}
function $89b2e5ff48034291$export$d5cd9e826e7bdb85(callback) {
    // Analogue to save() but need its own buffer to keep save buffer intact
    $89b2e5ff48034291$var$unveilBuffer = $89b2e5ff48034291$var$screen.innerHTML;
    $89b2e5ff48034291$export$42ffd38884aecdac();
    const paragraphs = $89b2e5ff48034291$var$unveilBuffer.split("p><p");
    paragraphs.map((p, i)=>{
        if (i === 0) paragraphs[i] += "p>";
        else if (i === paragraphs.length - 1) paragraphs[i] = "<p" + paragraphs[i];
        else paragraphs[i] = "<p" + paragraphs[i] + "p>";
    });
    let i = 0;
    function step() {
        $89b2e5ff48034291$var$screen.innerHTML += paragraphs[i];
        $89b2e5ff48034291$var$currentLine = $89b2e5ff48034291$var$screen.querySelector("p:last-of-type");
        if (i < paragraphs.length - 1) $89b2e5ff48034291$var$timeout = setTimeout(step, LSI);
        else if (typeof callback === "function") callback();
        i++;
    }
    step();
}
// Display a choice list with optional title to be answered with a key press
// `answers` param is an object: { keyName: [answerText, callback]}
// Example:
//  screen.choice('Votre réponse:', {
//      '1': ['Ben.. Je sais pas trop...', passageB],
//      '2': ['Heu... Je vois rien...', passageC],
//  });
// Would yield:
//  Votre réponse:
//    [1] Ben.. Je sais pas trop...
//    [2] Heu... Je vois rien...
//  > 
function $89b2e5ff48034291$export$7a5825874deea16a(title, answers) {
    // Display optional title
    if (title) $89b2e5ff48034291$export$21a5ca8aa77d35ff(title);
    let seq = "";
    // Display one choice per line
    for (const [key, answer] of Object.entries(answers)){
        const indent = 5 + key.length;
        const maxLength = 80 - indent;
        const lines = $4a239e940479063f$export$89440da1893f4202(answer[0], maxLength);
        lines.forEach((line, index)=>{
            if (index === 0) seq += `[${key}] ${line}\n`;
            else seq += "".padStart(indent) + line + "\n";
        });
    }
    $89b2e5ff48034291$export$b28a6436aebad9c0(seq.trim(), {
        color: "col-dark-cyan",
        lead: "  ",
        lineDelay: 100,
        endDelay: 100,
        mode: "line",
        newLineAtStart: false,
        newLineAtEnd: false
    }, ()=>{
        // Display prompt
        $89b2e5ff48034291$export$21a5ca8aa77d35ff("> ", "col-cyan");
        $89b2e5ff48034291$export$58734539bbfa41a2();
        $30572c7036fbadd2$export$a23ad60f6022999e("question");
    });
    registerKeyDownEvent();
    // Local one-time event listener
    function registerKeyDownEvent() {
        document.addEventListener("keydown", (e)=>{
            const answer = Object.entries(answers).find((answer)=>answer[0] === e.key);
            if (answer) {
                $89b2e5ff48034291$export$10d8903dec122b9d(answer[1][0]);
                $30572c7036fbadd2$export$a23ad60f6022999e("validate");
                answer[1][1]();
            } else {
                console.log("Invalid answer given:", e.key);
                registerKeyDownEvent();
            }
        }, {
            once: true
        });
    }
}
function $89b2e5ff48034291$export$34c871b8a7d7e324(title, callback) {
    // Display optional title
    if (title) $89b2e5ff48034291$export$21a5ca8aa77d35ff(title);
    // Display prompt
    $89b2e5ff48034291$export$21a5ca8aa77d35ff("> ", "col-cyan");
    $89b2e5ff48034291$export$58734539bbfa41a2();
    $30572c7036fbadd2$export$a23ad60f6022999e("question");
    registerKeyDownEvent();
    let answer = "";
    // Local one-time event listener
    function registerKeyDownEvent() {
        document.addEventListener("keydown", (e)=>{
            if (e.key == "Enter") {
                $30572c7036fbadd2$export$a23ad60f6022999e("validate");
                callback(answer);
            } else if (e.key == "Backspace") {
                if (answer.length) {
                    // Remove last keystroke from command line on screen
                    $89b2e5ff48034291$export$1ea584ca7009bcc1();
                    // Remove last keystroke from command line
                    answer = answer.slice(0, -1);
                }
                registerKeyDownEvent();
            } else {
                if (e.key.length == 1) {
                    // Add keystroke to answer and screen buffer
                    answer += e.key;
                    $89b2e5ff48034291$export$10d8903dec122b9d(e.key);
                }
                // Enable next keystroke
                registerKeyDownEvent();
            }
        }, {
            once: true
        });
    }
}


// Autrona Acoustic Computer Program: Remote
// Connect to a remote terminal



var $e5576a2b7fbfef2e$exports = {};

$parcel$export($e5576a2b7fbfef2e$exports, "init", function () { return $e5576a2b7fbfef2e$export$2cd8252107eb640b; });
$parcel$export($e5576a2b7fbfef2e$exports, "run", function () { return $e5576a2b7fbfef2e$export$889ea624f2cb2c57; });
$parcel$export($e5576a2b7fbfef2e$exports, "keyStroke", function () { return $e5576a2b7fbfef2e$export$ffc3b37567fab60c; });
$parcel$export($e5576a2b7fbfef2e$exports, "exit", function () { return $e5576a2b7fbfef2e$export$5c525e238923a57d; });
// Autrona Acoustic Computer Program: Pluie
// Une première expérience



// Variables
let $e5576a2b7fbfef2e$var$keyBoardResponsive = false;
let $e5576a2b7fbfef2e$var$prompt;
let $e5576a2b7fbfef2e$var$userName;
let $e5576a2b7fbfef2e$var$nextPart = $e5576a2b7fbfef2e$var$part1;
let $e5576a2b7fbfef2e$var$rainTrack;
let $e5576a2b7fbfef2e$var$exitCallback;
// Initialize module
function $e5576a2b7fbfef2e$export$2cd8252107eb640b() {}
function $e5576a2b7fbfef2e$export$889ea624f2cb2c57(exitCb) {
    $e5576a2b7fbfef2e$var$exitCallback = exitCb;
    $e5576a2b7fbfef2e$var$prompt = ""; // Reset
    $e5576a2b7fbfef2e$var$resetScreen();
    // Screen sequence. See screen.js comments for documentation
    const seq = [
        500,
        "!s:col-green",
        "rat34-a> ",
        3000,
        "!t:Votre nam \xa7\xa7\xa7om ?:00",
        500,
        "!n",
        100,
        "> "
    ];
    $89b2e5ff48034291$export$49bb65c2ea163039(seq, ()=>{
        $30572c7036fbadd2$export$a23ad60f6022999e("question");
        $e5576a2b7fbfef2e$var$enablePrompt();
    });
    document.addEventListener("keydown", $e5576a2b7fbfef2e$var$handleKeyDowns);
    document.addEventListener("keyup", $e5576a2b7fbfef2e$var$handleKeyUps);
}
// General keydown event callback
function $e5576a2b7fbfef2e$var$handleKeyDowns(e) {
    //console.log('Keystroke:', e.key)
    $e5576a2b7fbfef2e$export$ffc3b37567fab60c(e.key, "down");
}
// keyup event callback
function $e5576a2b7fbfef2e$var$handleKeyUps(e) {
    $e5576a2b7fbfef2e$export$ffc3b37567fab60c(e.key, "up");
}
function $e5576a2b7fbfef2e$export$ffc3b37567fab60c(key, state) {
    if (state == "down" && $e5576a2b7fbfef2e$var$keyBoardResponsive) switch(key){
        case "Backspace":
            if ($e5576a2b7fbfef2e$var$prompt.length) {
                // Remove last keystroke from command line on screen
                $89b2e5ff48034291$export$1ea584ca7009bcc1();
                // Remove last keystroke from command line
                $e5576a2b7fbfef2e$var$prompt = $e5576a2b7fbfef2e$var$prompt.slice(0, -1);
            }
            break;
        case "Enter":
            $30572c7036fbadd2$export$a23ad60f6022999e("validate");
            $e5576a2b7fbfef2e$var$keyBoardResponsive = false;
            $89b2e5ff48034291$export$dc84f6841f96b7da();
            $e5576a2b7fbfef2e$var$nextPart();
            break;
        default:
            if (key.length == 1) {
                // Add keystroke to screen buffer
                $89b2e5ff48034291$export$10d8903dec122b9d(key);
                // Add keystroke to command line
                $e5576a2b7fbfef2e$var$prompt += key;
            }
    }
}
function $e5576a2b7fbfef2e$var$enablePrompt() {
    $e5576a2b7fbfef2e$var$prompt = "";
    $89b2e5ff48034291$export$58734539bbfa41a2();
    $e5576a2b7fbfef2e$var$keyBoardResponsive = true;
}
function $e5576a2b7fbfef2e$var$resetScreen() {
    $89b2e5ff48034291$export$42ffd38884aecdac();
    $89b2e5ff48034291$export$21a5ca8aa77d35ff(" AutronaTerm v2.5 - 802.11                                     ", "col-red", "col-bg-red");
    $89b2e5ff48034291$export$35bfa795e607ffd5();
    $89b2e5ff48034291$export$dc84f6841f96b7da();
    $89b2e5ff48034291$export$dc84f6841f96b7da();
}
function $e5576a2b7fbfef2e$var$part1() {
    $e5576a2b7fbfef2e$var$nextPart = $e5576a2b7fbfef2e$var$part2;
    $e5576a2b7fbfef2e$var$userName = $e5576a2b7fbfef2e$var$prompt;
    // Screen sequence. See screen.js comments for documentation
    const seq = [
        500,
        "!s:col-green",
        "rat34-a> ",
        500,
        `!t:Bonjour ${$e5576a2b7fbfef2e$var$userName} !:00`,
        "!n",
        500,
        "!s:col-green",
        "",
        500,
        "!t:Je suis tr\xe8s content de vous retrouver sur le Terminal.:00",
        "!n",
        1000,
        "!s:col-green",
        "",
        500,
        "!t:\xc7a doit bien faire quelques heures que l\u2019on ne s\u2019est pas parl\xe9.:00",
        "!n",
        1000,
        "!s:col-green",
        "",
        500,
        "!t:Comment vous al:00",
        '!h:<span class="col-dark-red">&lt;!@&gt;</span>',
        "!n",
        100,
        "!s:italic",
        "!s:col-dark-red",
        "<remote connection error>",
        "!n",
        50,
        "!s:col-dark-red",
        "Hit [ENTER] to reconnect",
        "!n",
        100,
        "> "
    ];
    $89b2e5ff48034291$export$49bb65c2ea163039(seq, ()=>{
        $30572c7036fbadd2$export$a23ad60f6022999e("error");
        $e5576a2b7fbfef2e$var$enablePrompt();
    });
}
function $e5576a2b7fbfef2e$var$part2() {
    $e5576a2b7fbfef2e$var$nextPart = $e5576a2b7fbfef2e$var$part3;
    $e5576a2b7fbfef2e$var$resetScreen();
    // Screen sequence. See screen.js comments for documentation
    const seq = [
        500,
        "!s:col-green",
        "rat34-a> ",
        500,
        "!t:Hmm...:00",
        "!n",
        750,
        "!s:col-green",
        "",
        500,
        "!t:navr\xe9.:00",
        "!n",
        1000,
        "!s:col-green",
        "",
        500,
        "!t:attendez.:00",
        "!n",
        5000,
        "!s:col-green",
        "",
        500,
        "!t:Juste un instant.:00",
        "!n",
        5000,
        "!s:col-green",
        "",
        500,
        "!t:Vous \xeates l\xe0 ?:00",
        "!n",
        500,
        "Oui [1] Mouaih [2] > "
    ];
    $89b2e5ff48034291$export$49bb65c2ea163039(seq, ()=>{
        $30572c7036fbadd2$export$a23ad60f6022999e("question");
        $e5576a2b7fbfef2e$var$enablePrompt();
    });
}
function $e5576a2b7fbfef2e$var$part3() {
    $e5576a2b7fbfef2e$var$nextPart = $e5576a2b7fbfef2e$var$part4;
    // TODO: Remap main.backgroundTrack loopStart and loopEnd to begin ramp to rainy loop
    //       → main.setLoopMarkers(loopStart, loopEnd)
    // Screen sequence. See screen.js comments for documentation
    const seq = [
        500,
        "!s:col-green",
        "rat34-a> ",
        500,
        `!t:Navr\xe9, navr\xe9 ${$e5576a2b7fbfef2e$var$userName}.:00`,
        "!n",
        500,
        "!s:col-green",
        "",
        500,
        "!t:Je sais c'est p\xe9nible mais j'ai:00",
        "!n",
        750,
        "!s:col-green",
        "",
        500,
        "!t:j'ai un petit probl\xe8me logistique.:00",
        "!n",
        1000,
        "!s:col-green",
        "",
        500,
        "!t:Attendez.:00",
        "!n",
        1000,
        "!s:col-green",
        "",
        500,
        "!t:Voil\xe0 !:00",
        "!n",
        750,
        "!s:col-green",
        "",
        500,
        "!t:J\u2019ai un petit probl\xe8me logistique... il pleut sur le Terminal...:00",
        "!n",
        500,
        "!s:col-green",
        "",
        500,
        "!t:C\u2019est... c'est un Terminal ext\xe9rieur.:00",
        "!n",
        500,
        "!s:col-green",
        "",
        500,
        "!t:J'essaie de le couvrir avec une b\xe2che tout en vous parlant.:00",
        "!n",
        750,
        "!s:col-green",
        "",
        500,
        "!t:Je vous re\xe7ois mais j'ai peur de ne plus pouvoir utiliser le clav:00",
        '!h:<span class="col-dark-red">&lt;!@&gt;</span>',
        "!n",
        4000,
        "!s:col-green",
        "",
        500,
        "!t:Je disais j'ai peur d:00",
        '!h:<span class="col-dark-red">&lt;!@&gt;</span>',
        "!n",
        500,
        "!s:italic",
        "!s:col-dark-red",
        "<remote connection error>",
        "!n",
        50,
        "!s:col-dark-red",
        "Hit [ENTER] to reconnect",
        "!n",
        100,
        "> "
    ];
    $89b2e5ff48034291$export$49bb65c2ea163039(seq, ()=>{
        $30572c7036fbadd2$export$a23ad60f6022999e("error");
        $e5576a2b7fbfef2e$var$enablePrompt();
    });
    // Lancer la pluie avec un lent fade in
    const rainCrossTime = 120;
    $e5576a2b7fbfef2e$var$rainTrack = $195f804eb85bb809$exports.play("rain", {
        loop: true,
        loopStart: 0.380,
        loopEnd: 11.121
    }).fadeTo(rainCrossTime, -18, -90, "expo");
    $30572c7036fbadd2$export$3f22255af92e0d9d.fade(rainCrossTime, -18, false, "expo");
    setTimeout(()=>{
        $30572c7036fbadd2$export$3f22255af92e0d9d.fade(rainCrossTime, -90, true, "expo");
    }, rainCrossTime * 1000);
}
function $e5576a2b7fbfef2e$var$part4() {
    $e5576a2b7fbfef2e$var$nextPart = $e5576a2b7fbfef2e$var$part5;
    $e5576a2b7fbfef2e$var$resetScreen();
    // Screen sequence. See screen.js comments for documentation
    const seq = [
        500,
        "!s:col-green",
        "rat34-a> ",
        500,
        "!t:Merci de vous \xeatre reconnect\xe9 pour qu'on puie continuer \xe0 e parler.:00",
        "!n",
        750,
        "!s:col-green",
        "",
        500,
        "!t:c'et vraiment tr\xe8s gentil:00",
        "!n",
        1000,
        "!s:col-green",
        "",
        500,
        "!t:Vou \xeate adorable. Vraiment.:00",
        "!n",
        1000,
        "!s:col-green",
        "",
        500,
        "!t:Bien, je vou \xe9coute !:00",
        "!n",
        500,
        "!s:col-green",
        "",
        500,
        "!t:Que pui-je faire p:00",
        '!h:<span class="col-dark-red">&lt;!@&gt;</span>',
        "!n",
        100,
        "!s:italic",
        "!s:col-dark-red",
        "<remote connection error>",
        "!n",
        50,
        "!s:col-dark-red",
        "Hit [ENTER] to reconnect",
        "!n",
        100,
        "> "
    ];
    $89b2e5ff48034291$export$49bb65c2ea163039(seq, ()=>{
        $30572c7036fbadd2$export$a23ad60f6022999e("error");
        $e5576a2b7fbfef2e$var$enablePrompt();
    });
}
function $e5576a2b7fbfef2e$var$part5() {
    $e5576a2b7fbfef2e$var$nextPart = $e5576a2b7fbfef2e$var$part6;
    $e5576a2b7fbfef2e$var$resetScreen();
    // Screen sequence. See screen.js comments for documentation
    const seq = [
        500,
        "!s:col-green",
        "rat34-a> ",
        500,
        "!t:Merci \xe0 nouveau.:00",
        "!n",
        500,
        "!s:col-green",
        "",
        500,
        "!t:Pffffffffffff cette pluie... et ce goutte ur le clavier.:00",
        "!n",
        1000,
        "!s:col-green",
        "",
        500,
        "!t:Je ui d\xe9ol\xe9 de vou faire endurer \xe7a !:00",
        "!n",
        750,
        "!s:col-green",
        "",
        500,
        "!t:Il pleut ur le clavier, je ne ai pa i vou recevez tou me texte.:00",
        "!n",
        750,
        "!s:col-green",
        "",
        500,
        "!t:Quelle et la lettre qui manque ?:00",
        "!n",
        100,
        "> "
    ];
    $89b2e5ff48034291$export$49bb65c2ea163039(seq, ()=>{
        $30572c7036fbadd2$export$a23ad60f6022999e("question");
        $e5576a2b7fbfef2e$var$enablePrompt();
    });
}
function $e5576a2b7fbfef2e$var$part6() {
    if ($e5576a2b7fbfef2e$var$prompt === "s") $e5576a2b7fbfef2e$var$part9();
    else {
        $e5576a2b7fbfef2e$var$nextPart = $e5576a2b7fbfef2e$var$part7;
        // Screen sequence. See screen.js comments for documentation
        const seq = [
            500,
            "!s:col-green",
            "rat34-a> ",
            500,
            "!t:Non, je ne croi pa que ce oit celle-l\xe0...:00",
            "!n",
            100,
            "> "
        ];
        $89b2e5ff48034291$export$49bb65c2ea163039(seq, ()=>{
            $30572c7036fbadd2$export$a23ad60f6022999e("question");
            $e5576a2b7fbfef2e$var$enablePrompt();
        });
    }
}
function $e5576a2b7fbfef2e$var$part7() {
    if ($e5576a2b7fbfef2e$var$prompt === "s") $e5576a2b7fbfef2e$var$part9();
    else {
        $e5576a2b7fbfef2e$var$nextPart = $e5576a2b7fbfef2e$var$part8;
        // Screen sequence. See screen.js comments for documentation
        const seq = [
            500,
            "!s:col-green",
            "rat34-a> ",
            500,
            "!t:Non vraiment, ce n\u2019et pa la bonne.:00",
            "!n",
            100,
            "> "
        ];
        $89b2e5ff48034291$export$49bb65c2ea163039(seq, ()=>{
            $30572c7036fbadd2$export$a23ad60f6022999e("question");
            $e5576a2b7fbfef2e$var$enablePrompt();
        });
    }
}
function $e5576a2b7fbfef2e$var$part8() {
    if ($e5576a2b7fbfef2e$var$prompt === "s") $e5576a2b7fbfef2e$var$part9();
    else {
        $e5576a2b7fbfef2e$var$nextPart = $e5576a2b7fbfef2e$var$part9;
        // Screen sequence. See screen.js comments for documentation
        const seq = [
            500,
            "!s:col-green",
            "rat34-a> ",
            500,
            "!t:Eco tez ! C\u2019et pa grave. Je vai me d\xe9broiller an...:00",
            "!n"
        ];
        $89b2e5ff48034291$export$49bb65c2ea163039(seq, ()=>{
            $e5576a2b7fbfef2e$var$nextPart();
        });
    }
}
function $e5576a2b7fbfef2e$var$part9() {
    $e5576a2b7fbfef2e$var$nextPart = $e5576a2b7fbfef2e$var$part10;
    // Screen sequence. See screen.js comments for documentation
    const seq = [
        1000,
        "!s:col-green",
        "rat34-a> ",
        500,
        "!t:Merde !:00",
        "!n",
        1000,
        "!s:col-green",
        "",
        500,
        "!t:Je croi qe j\u2019ai encore n probl\xe8me avec ne atre lettre:00",
        "!n",
        3000,
        "!s:col-green",
        "",
        500,
        "!t:Attendez.:00",
        "!n",
        1000,
        "!s:col-green",
        "",
        500,
        "!t:Je revien:00",
        "!n",
        2000,
        "!s:italic",
        "!s:col-dark-yellow",
        "<remote host on hold>",
        "!n",
        100,
        "!s:italic",
        "!s:col-dark-yellow",
        "Please wait for remote host",
        "!t:....................:1000",
        "!n",
        500,
        "!s:col-green",
        "rat34-a> ",
        500,
        "!t:Voil\xe0. Vo \xeate l\xe0 ? Je croi qe j\u2019ai trov\xe9 ne oltion.:00",
        "!n",
        500,
        "!s:col-green",
        "",
        500,
        "!t:Mai vo devez d\u2019abord l\u2019accepter:00",
        "!n",
        500,
        "Accepter [1] Refuser [2] > "
    ];
    $89b2e5ff48034291$export$49bb65c2ea163039(seq, ()=>{
        $30572c7036fbadd2$export$a23ad60f6022999e("question");
        $e5576a2b7fbfef2e$var$enablePrompt();
    });
}
function $e5576a2b7fbfef2e$var$part10() {
    if ($e5576a2b7fbfef2e$var$prompt === "1") $e5576a2b7fbfef2e$var$part12();
    else {
        $e5576a2b7fbfef2e$var$nextPart = $e5576a2b7fbfef2e$var$part11;
        // Screen sequence. See screen.js comments for documentation
        const seq = [
            500,
            "!s:col-green",
            "rat34-a> ",
            500,
            "!t:N'ayez pa per ! Vo ne riqez rien.:00",
            "!n",
            500,
            "Accepter tout de m\xeame [1] Refuser d\xe9finitivement [2] > "
        ];
        $89b2e5ff48034291$export$49bb65c2ea163039(seq, ()=>{
            $30572c7036fbadd2$export$a23ad60f6022999e("question");
            $e5576a2b7fbfef2e$var$enablePrompt();
        });
    }
}
function $e5576a2b7fbfef2e$var$part11() {
    if ($e5576a2b7fbfef2e$var$prompt === "1") $e5576a2b7fbfef2e$var$part12();
    else {
        // Screen sequence. See screen.js comments for documentation
        const seq = [
            500,
            "!s:col-green",
            "rat34-a> ",
            500,
            "!t:Ma foi. Tant pi alor. C'et trop difficile de comm niqer aini !:00",
            "!n",
            500,
            "!s:col-green",
            "rat34-a> ",
            500,
            "!t:Recontactez-moi demain i \xe7a ne vo d\xe9range pa. A revoir !:00",
            "!n",
            2000
        ];
        $89b2e5ff48034291$export$49bb65c2ea163039(seq, ()=>{
            $e5576a2b7fbfef2e$var$part15();
        });
    }
}
function $e5576a2b7fbfef2e$var$part12() {
    $e5576a2b7fbfef2e$var$nextPart = $e5576a2b7fbfef2e$var$part13;
    const seq = [
        200,
        "!s:col-dark-green",
        "<buffering...>",
        "!n",
        800,
        "!s:col-dark-green",
        "<audio streaming enabled>",
        "!n",
        1000
    ];
    $89b2e5ff48034291$export$49bb65c2ea163039(seq, ()=>{
        $195f804eb85bb809$exports.play("allo", {
            onended: ()=>{
                const seq = [
                    500,
                    "Oui je vous entends [1] Non, rien dans le casque [2] > "
                ];
                $89b2e5ff48034291$export$49bb65c2ea163039(seq, ()=>{
                    $30572c7036fbadd2$export$a23ad60f6022999e("question");
                    $e5576a2b7fbfef2e$var$enablePrompt();
                });
            }
        });
    });
}
function $e5576a2b7fbfef2e$var$part13() {
    $e5576a2b7fbfef2e$var$nextPart = $e5576a2b7fbfef2e$var$part14;
    if ($e5576a2b7fbfef2e$var$prompt === "2") $e5576a2b7fbfef2e$var$part11();
    else $195f804eb85bb809$exports.play("vocal", {
        onended: ()=>{
            const seq = [
                500,
                "Arr\xeater la pluie [1] > "
            ];
            $89b2e5ff48034291$export$49bb65c2ea163039(seq, ()=>{
                $30572c7036fbadd2$export$a23ad60f6022999e("success");
                $e5576a2b7fbfef2e$var$enablePrompt();
            });
        }
    });
}
function $e5576a2b7fbfef2e$var$part14() {
    //main.fullFillTask('pluie');
    $d483974069d0054d$export$51b36263b660c3ee(0.5);
    $195f804eb85bb809$exports.play("merci", {
        onended: ()=>{
            $e5576a2b7fbfef2e$var$part15();
        }
    });
}
function $e5576a2b7fbfef2e$var$part15() {
    $30572c7036fbadd2$export$a23ad60f6022999e("disconnected");
    const seq = [
        100,
        "!s:italic",
        "!s:col-dark-red",
        "<remote host disconnected>",
        "!n",
        100,
        "!s:italic",
        "!s:col-dark-red",
        "<connection closed>",
        "!n"
    ];
    $89b2e5ff48034291$export$49bb65c2ea163039(seq, ()=>{
    //exit();
    });
}
function $e5576a2b7fbfef2e$export$5c525e238923a57d() {
    $89b2e5ff48034291$export$42ffd38884aecdac();
    $e5576a2b7fbfef2e$var$exitCallback();
}


// Variables
let $2f9de8feb91518c1$var$keyBoardResponsive = true;
let $2f9de8feb91518c1$var$address;
let $2f9de8feb91518c1$var$audioSource;
// Configuration
const $2f9de8feb91518c1$var$dialUp = true;
// Game data
const $2f9de8feb91518c1$var$addresses = {
    "10.1.2.124": $e5576a2b7fbfef2e$exports
};
function $2f9de8feb91518c1$export$889ea624f2cb2c57(...args) {
    $2f9de8feb91518c1$var$keyBoardResponsive = true;
    $2f9de8feb91518c1$var$address = args[0] || "";
    $89b2e5ff48034291$export$a1544dad697b423d();
    $89b2e5ff48034291$export$42ffd38884aecdac();
    // Header
    $89b2e5ff48034291$export$dc84f6841f96b7da();
    // Screen sequence. See screen.js comments for documentation
    const seq = [
        100,
        "AutronaTerm v2.5 - 802.11",
        "!s:col-red",
        "!s:col-bg-red",
        100,
        "!n",
        100,
        "!n"
    ];
    $89b2e5ff48034291$export$49bb65c2ea163039(seq, ()=>{
        if ($2f9de8feb91518c1$var$address) {
            $89b2e5ff48034291$export$10d8903dec122b9d("Connecting to " + $2f9de8feb91518c1$var$address);
            $2f9de8feb91518c1$var$openConnection();
        } else {
            $89b2e5ff48034291$export$10d8903dec122b9d("Enter remote terminal address > ");
            $89b2e5ff48034291$export$58734539bbfa41a2();
        }
    });
}
function $2f9de8feb91518c1$var$openConnection() {
    $2f9de8feb91518c1$var$keyBoardResponsive = false;
    if ($2f9de8feb91518c1$var$address in $2f9de8feb91518c1$var$addresses) {
        if ($2f9de8feb91518c1$var$dialUp) {
            // Play modem dial up sound
            $2f9de8feb91518c1$var$audioSource = $195f804eb85bb809$exports.play("dial-up-modem", {
                initialGain: -20
            });
            // Screen sequence. See screen.js comments for documentation
            const seq = `
                \xa71000<opening line>
                \xa7800<dialing ISP...>
                \xa74300<initiating connection...>
                \xa73900<negotiating modulation mode...>
                \xa73200<probing line...>
                \xa71400<adjusting equalizers...>

                \xa79200<connection established>

                \xa72200<muting modem>

                \xa7500<remote tty override from ${$2f9de8feb91518c1$var$address}>
            `.trim();
            $89b2e5ff48034291$export$b28a6436aebad9c0(seq, {
                color: [
                    "col-dark-green",
                    "italic"
                ],
                mode: "line",
                lineDelay: 0,
                endDelay: 0
            }, ()=>{
                setTimeout(()=>{
                    $2f9de8feb91518c1$var$stopSounds();
                    $2f9de8feb91518c1$var$addresses[$2f9de8feb91518c1$var$address].run($2f9de8feb91518c1$var$exit);
                }, 2000);
            });
        } else {
            $89b2e5ff48034291$export$dc84f6841f96b7da();
            // Screen sequence. See screen.js comments for documentation
            const seq = [
                100,
                "!s:col-dark-green",
                "<initiating connection...>",
                "!n",
                5160,
                "!s:col-green",
                "<connection established>",
                "!n"
            ];
            $89b2e5ff48034291$export$49bb65c2ea163039(seq, ()=>{
                $30572c7036fbadd2$export$a23ad60f6022999e("connected");
                setTimeout(()=>{
                    $2f9de8feb91518c1$var$stopSounds();
                    $2f9de8feb91518c1$var$addresses[$2f9de8feb91518c1$var$address].run($2f9de8feb91518c1$var$exit);
                }, 1000);
            });
        }
    } else {
        console.log("Bad address: " + $2f9de8feb91518c1$var$address);
        $2f9de8feb91518c1$var$address = "";
        $89b2e5ff48034291$export$dc84f6841f96b7da();
        // Screen sequence. See screen.js comments for documentation
        const seq = [
            100,
            "!s:col-dark-green",
            "<initiating connection...>",
            "!n",
            5160,
            "!s:col-dark-red",
            "<unable to reach host>",
            "!n",
            100,
            "Enter remote terminal address > "
        ];
        $89b2e5ff48034291$export$49bb65c2ea163039(seq, ()=>{
            $30572c7036fbadd2$export$a23ad60f6022999e("error");
            $89b2e5ff48034291$export$58734539bbfa41a2();
            $2f9de8feb91518c1$var$keyBoardResponsive = true;
        });
    }
}
function $2f9de8feb91518c1$var$stopSounds() {
    if ($2f9de8feb91518c1$var$audioSource) $2f9de8feb91518c1$var$audioSource.stop();
}
function $2f9de8feb91518c1$var$exit() {
    console.log("Remote program exit");
}




function $9ff7549d7a8ee488$export$2cd8252107eb640b() {
    document.querySelector(".js-start").addEventListener("click", ()=>{
        if (DEVMODE) console.log("Starting...");
        document.querySelector(".js-start").classList.add("hidden");
        document.querySelector(".center").classList.add("hidden");
        document.querySelector(".screen").classList.remove("hidden");
        $d483974069d0054d$export$fbb4d68fe60c1629().then(()=>{
            $30572c7036fbadd2$export$b3571188c770cc5a();
        });
    });
}
function $9ff7549d7a8ee488$export$471f7ae5c4103ae1(status) {
    const statusEl = document.querySelector("#status");
    if (status === null) statusEl.classList.add("hidden");
    else statusEl.classList.remove("hidden");
    statusEl.innerText = status;
}
function $9ff7549d7a8ee488$export$4bb981a91e4f02eb() {
    document.querySelector(".js-start").classList.remove("hidden");
    $9ff7549d7a8ee488$export$471f7ae5c4103ae1(null);
}



var $cc9c122e54441cea$exports = {};

$cc9c122e54441cea$exports = (parcelRequire("aNJCr")).getBundleURL("2u7YE") + "../ui-pack.01f87fb1.aac";


var $2dbeb1698d575110$exports = {};

$2dbeb1698d575110$exports = (parcelRequire("aNJCr")).getBundleURL("2u7YE") + "../Dial_up_modem_noises.fcf212dc.aac";


var $d70372f3e8b8ef33$exports = {};

$d70372f3e8b8ef33$exports = (parcelRequire("aNJCr")).getBundleURL("2u7YE") + "../fan-loop.00ef9ea2.wav";


var $db6274a084f917b1$exports = {};

$db6274a084f917b1$exports = (parcelRequire("aNJCr")).getBundleURL("2u7YE") + "../RAIN_Heavy_loop_stereo_01.a46bc133.aac";


var $0b398e5f6d8335e5$exports = {};

$0b398e5f6d8335e5$exports = (parcelRequire("aNJCr")).getBundleURL("2u7YE") + "../HZ_Allo.df799dd6.mp3";


var $97029902280eed21$exports = {};

$97029902280eed21$exports = (parcelRequire("aNJCr")).getBundleURL("2u7YE") + "../HZ_Vocal.d7be1088.mp3";


var $480dde0b4edf7b9a$exports = {};

$480dde0b4edf7b9a$exports = (parcelRequire("aNJCr")).getBundleURL("2u7YE") + "../HZ_Merci.1af0b4b4.mp3";


const $eefd8250a63a697c$var$sounds = [
    {
        name: "ui-pack",
        url: new URL($cc9c122e54441cea$exports)
    },
    {
        name: "dial-up-modem",
        url: new URL($2dbeb1698d575110$exports)
    },
    {
        name: "fan-loop",
        url: new URL($d70372f3e8b8ef33$exports)
    },
    {
        name: "rain",
        url: new URL($db6274a084f917b1$exports)
    },
    {
        name: "allo",
        url: new URL($0b398e5f6d8335e5$exports)
    },
    {
        name: "vocal",
        url: new URL($97029902280eed21$exports)
    },
    {
        name: "merci",
        url: new URL($480dde0b4edf7b9a$exports)
    }
];
function $eefd8250a63a697c$export$2cd8252107eb640b() {
    $eefd8250a63a697c$var$setupMobileKeyboard();
    return $eefd8250a63a697c$var$loadSounds();
}
function $eefd8250a63a697c$var$loadSounds() {
    return Promise.all([
        ...$eefd8250a63a697c$var$sounds.map((sound)=>{
            return $195f804eb85bb809$exports.load(sound.name, sound.url);
        })
    ]).then(()=>{
        if (DEVMODE) console.log("All sounds loaded");
    });
}
function $eefd8250a63a697c$var$setupMobileKeyboard() {
    // Trigger mobile keyboard on screen click
    const screenElement = document.querySelector(".screen");
    // Focus input on screen click, raising the keyboard
    screenElement.addEventListener("click", ()=>{
        const input = document.querySelector(".mobile-input");
        input.focus();
    });
    // Prevent hitting enter submitting the mobile form for input
    document.querySelector("form").addEventListener("keypress", (e)=>e.preventDefault());
}


// Development
window.DEVMODE = true;
// Config
window.LSI = 25; // Line Sequence Interval (Used in screen.sequence and unveil
// calls for line by line time interval in milliseconds)
// Sound references
let $30572c7036fbadd2$export$3f22255af92e0d9d = null;
function $30572c7036fbadd2$export$a23ad60f6022999e(name) {
    // TODO: refactor this
    const effects = {
        "validate": {
            initialGain: -12,
            offset: 0.100,
            duration: 0.093
        },
        "error": {
            initialGain: -12,
            offset: 0.200,
            duration: 0.175
        },
        "success": {
            initialGain: -12,
            offset: 0.400,
            duration: 0.148
        },
        "question": {
            initialGain: -12,
            offset: 0.600,
            duration: 0.131
        },
        "notify": {
            initialGain: -12,
            offset: 0.800,
            duration: 0.340
        },
        "connected": {
            initialGain: -18,
            offset: 1.200,
            duration: 0.147
        },
        "disconnected": {
            initialGain: -18,
            offset: 1.400,
            duration: 0.297
        },
        "connecting": {
            initialGain: -18,
            offset: 1.800,
            duration: 5.160
        }
    };
    if (!(name in effects)) return console.error("Error: Uknown soundEffect: " + name);
    $195f804eb85bb809$exports.play("ui-pack", effects[name]);
}
function $30572c7036fbadd2$var$init() {
    $9ff7549d7a8ee488$export$2cd8252107eb640b();
    $9ff7549d7a8ee488$export$471f7ae5c4103ae1("Initializing...");
    $d483974069d0054d$export$2cd8252107eb640b();
    $89b2e5ff48034291$export$2cd8252107eb640b();
    $9ff7549d7a8ee488$export$471f7ae5c4103ae1("Loading...");
    $eefd8250a63a697c$export$2cd8252107eb640b().then(()=>{
        $9ff7549d7a8ee488$export$4bb981a91e4f02eb();
    });
}
function $30572c7036fbadd2$export$b3571188c770cc5a() {
    $30572c7036fbadd2$export$3f22255af92e0d9d = $195f804eb85bb809$exports.play("fan-loop", {
        loop: true,
        initialGain: -90
    }).fadeTo(5, -8);
    $2f9de8feb91518c1$export$889ea624f2cb2c57("10.1.2.124");
}
$30572c7036fbadd2$var$init();

})();
//# sourceMappingURL=index.579b3f4f.js.map
